import { API_URL } from '../../../../constants'

const LOGS_API = `${API_URL}/api/internal/logs`

export const FETCH_LOGIN_EVENTS_LOGS_URL = `${LOGS_API}/login-event`
export const FETCH_USER_EVENTS_LOGS_URL = `${LOGS_API}/user-event`

export const FETCH_REQUISITE_HISTORY_LOGS_URL = `${LOGS_API}/requisite-history`
export const FETCH_EXTERNAL_USER_FLAGS_LOGS_URL = `${LOGS_API}/external-user-flags`

export const GET_INCOMING_LOGS_URL = `${API_URL}/api/sms/incoming-log`

export const FETCH_RISK_SCORE_LOGS_URL = `${LOGS_API}/risk-score-changes`

const AUDIT_API = `${API_URL}/api/internal/audit`
export const FETCH_AUDIT_LOGS_URL = `${AUDIT_API}/logs`
export const FETCH_AUDIT_TOPICS_URL = `${AUDIT_API}/topics`
